<div class="component-container flex flex-col gap-[40px]">
  <app-change-in-work-request-filters class="filters-section mt-[40px]" />
  <app-change-in-work-request-list class="list-section" />
</div>
